import $ from 'jquery';
import _ from 'underscore';
import Cache from 'root/cache';
import Modals from 'root/modals';
import View from 'view/base';
import {showAutoReplyMessage, deleteComment} from 'service/feedback';

export default View.extend({
    className: 'group-buttons',
    events: {
        'click .priority-set'               : 'setPriority',
        'click .status-set'                 : 'setWorkflow',
        'click .assignee-set'               : 'setUser',
        'click .category-set'               : 'setCategory',
        'click .merge'                      : 'merge',
        'click .move'                       : 'move',
        'click .delete'                     : 'delete',
        'click .integration-set'            : 'setIntegration',
        'click .due-date-set'               : 'setDueDate',
    },

    dom_handlers: {
        setPriority: function(e) {
            var selected_feedback = Cache.feedback.where({selected: true});

            var ids = [];
            _.each(selected_feedback, (model) => {
                ids.push(model.id);
            });

            Modals.editFeedbackPriority(ids, () => {
                _.each(selected_feedback, (model) => {
                    model.set({
                        selected: false,
                        update  : model.get('update') ? false: true,
                    })
                });
            });
        },

        setWorkflow: function(e) {
            var selected_feedback = Cache.feedback.where({selected: true});

            var ids = [];
            _.each(selected_feedback, (model) => {
                ids.push(model.id);
            });

            Modals.editFeedbackWorkflow(ids, (autoreply_comments) => {
                if (autoreply_comments.length === 0) {
                    return;
                }

                const autoreply_comment_ids = autoreply_comments.map((comment) => comment.id);
                showAutoReplyMessage(() => {
                    deleteComment(autoreply_comment_ids);
                });

                // Get all the comments
                autoreply_comments.forEach((autoreply_comment) => {
                    if (!Cache.feedback_comment.get(autoreply_comment.id)) {
                        Cache.feedback_comment.add(autoreply_comment);
                    }
                });

                _.each(selected_feedback, (model) => {
                    model.set({
                        selected: false,
                        update  : model.get('update') ? false: true
                    })
                });
            });
        },

        setCategory: function(e) {
            var selected_feedback = Cache.feedback.where({selected: true});

            var ids = [];
            _.each(selected_feedback, (model) => {
                ids.push(model.id);
            });

            Modals.editFeedbackCategory(ids, () => {
                _.each(selected_feedback, (model) => {
                    model.set({
                        selected : false,
                        update   : model.get('update') ? false: true,
                    });
                });
            });
        },

        merge: function(e) {
            var selected_feedback = Cache.feedback.where({selected: true});

            var merge_feedback_ids = [];
            var primary_feedback_id = '';
            _.each(selected_feedback, (model, index) => {
                if (index === 0) {
                    primary_feedback_id = model.id;
                    return;
                }

                merge_feedback_ids.push(model.id);
            });

            Modals.mergeFeedback(primary_feedback_id, merge_feedback_ids, {}, () => {
                _.each(selected_feedback, (model) => {
                    model.set({
                        selected: false,
                        update  : model.get('update') ? false: true,
                    })
                });
            });
        },

        move: function(e) {
            var selected_feedback = Cache.feedback.where({selected: true});

            var ids = selected_feedback.map((model) => model.id);

            Modals.moveFeedback(ids);
        },

        delete: function(e) {
            var selected_feedback = Cache.feedback.where({selected: true});

            var ids = [];
            _.each(selected_feedback, function(model) {
                ids.push(model.id);
            });

            Modals.deleteFeedback(ids, function() {
                $(e.currentTarget).addClass('loading').prop('disabled', true);
            }, function() {
                $(e.currentTarget).removeClass('loading').prop('disabled', false);
            });
        },

        setUser: function(e) {
            var selected_feedback = Cache.feedback.where({selected: true});

            var ids = [];
            _.each(selected_feedback, (model) => {
                ids.push(model.id);
            });

            Modals.editFeedbackAssignee(ids, () => {
                _.each(selected_feedback, (model) => {
                    model.set({
                        selected: false,
                        update  : model.get('update') ? false: true,
                    })
                });
            });
        },

        setIntegration: function(e) {
            var selected_feedback = Cache.feedback.where({selected: true});

            var feedback_ids = [];

            _.each(selected_feedback, (model) => {
                feedback_ids.push(model.id);
            });

            Modals.editFeedbackIntegration(feedback_ids, (result) => {
                _.each(selected_feedback, function(model) {
                    model.set({
                        selected: false,
                        update  : model.get('update') ? false: true,
                    });
                });

                if (result && this.view_type === 'inbox') {
                    Cache.feedback.startPolling();
                }
            });
        },

        setDueDate: function(e) {
            var selected_feedback = Cache.feedback.where({selected: true});

            var ids = [];
            _.each(selected_feedback, (model) => {
                ids.push(model.id);
            });

            Modals.editFeedbackDueDate(ids, () => {
                _.each(selected_feedback, (model) => {
                    model.set({
                        selected: false,
                        update  : model.get('update') ? false: true,
                    })
                });
            });
        }
    },

    initialize: function(options) {
        this.is_design = !!options.is_design;
        this.view_type = options.view_type;

        this.listenTo(Cache.workflow, 'change', this.render);
        this.listenTo(Cache.workflow, 'add',    this.render);
        this.listenTo(Cache.workflow, 'remove', this.render);
    },

    render: function() {
        var integrations_list = [
            {
                integration: Cache.integration_jira.findWhere({project_id: Cache.default_project_id}),
                name: 'Jira'
            },
            {
                integration: Cache.integration_teamwork.findWhere({project_id: Cache.default_project_id}),
                name: 'Teamwork'
            },
            {
                integration: Cache.integration_trello.findWhere({project_id: Cache.default_project_id}),
                name: 'Trello'
            },
            {
                integration: Cache.integration_basecamp.findWhere({project_id: Cache.default_project_id}),
                name: 'Basecamp'
            },
            {
                integration: Cache.integration_github.findWhere({project_id: Cache.default_project_id}),
                name: 'GitHub'
            },
            {
                integration: Cache.integration_gitlab.findWhere({project_id: Cache.default_project_id}),
                name: 'GitLab'
            },
            {
                integration: Cache.integration_linear.findWhere({project_id: Cache.default_project_id}),
                name: 'Linear'
            },
            {
                integration: Cache.integration_asana.findWhere({project_id: Cache.default_project_id}),
                name: 'Asana'
            },
            {
                integration: Cache.integration_clickup.findWhere({project_id: Cache.default_project_id}),
                name: 'ClickUp'
            },
            {
                integration: Cache.integration_wrike.findWhere({project_id: Cache.default_project_id}),
                name: 'Wrike'
            },
            {
                integration: Cache.integration_azure_devops.findWhere({project_id: Cache.default_project_id}),
                name: 'Azure DevOps'
            },
            {
                integration: Cache.integration_monday.findWhere({project_id: Cache.default_project_id}),
                name: 'Monday'
            },
            {
                integration: Cache.integration_notion.findWhere({project_id: Cache.default_project_id}),
                name: 'Notion'
            },
            {
                integration: Cache.integration_zendesk.findWhere({project_id: Cache.default_project_id}),
                name: 'Zendesk'
            },
        ];

        var connected_integrations = [];

        integrations_list.forEach((item) => {
            if (item.integration && item.integration.isConnected()) {
                connected_integrations.push(item.name);
            }
        });

        var content =
        (!connected_integrations.length ? '' :
        '<button type="button" class="integration-set square small tertiary">Send to ' + (connected_integrations.length === 1 ? connected_integrations[0] : 'integration') + '</button>') +
        '<button type="button" class="status-set square small tertiary">Status</button>' +
        '<button type="button" class="assignee-set square small tertiary">Assignee</button>' +
        '<button type="button" class="priority-set square small tertiary">Priority</button>' +
        '<button type="button" class="category-set square small tertiary">Category</button>' +
        '<button type="button" class="due-date-set square small tertiary">Due date</button>' +
        (this.is_design ? '' :
        '<button type="button" class="merge square small tertiary">Merge Duplicates</button>') +
        '<button type="button" class="move square small tertiary">Move</button>' +
        '<button type="button" class="delete square small secondary">Delete</button>';

        this.$el.html(content);

        return this;
    }
});